import { type EasyScore, Factory, type System } from "vexflow";

function appendSystem(score: EasyScore, prevSystem: System | null): System {
	const factory = score.factory;
	const systemStave = {
		voices: [score.voice(score.notes("C4/q, C4, C4, C4"))],
	};
	const system = factory.System({
		width: prevSystem == null ? 300 : 250,
		spaceBetweenStaves: 10,
	});
	const stave = system.addStave(systemStave);
	system.addConnector("singleRight");
	if (prevSystem == null) {
		stave.addClef("treble").addTimeSignature("4/4").addKeySignature("Eb");
		system.addConnector("singleLeft");
	} else {
		prevSystem.format();
		const bb = prevSystem.getBoundingBox();
		if (bb == null) {
			throw new Error("Bounding box not calculated");
		}
		system.setX(prevSystem.getX() + bb.getW());
		system.setY(prevSystem.getY());
	}
	return system;
}

/**
 * Draws a staff for testing purposes.
 * @param div the element in which a staff will be rendered
 */
export function drawSample(div: HTMLDivElement): void {
	const factory = Factory.newFromElementId(div.id, 1000, 400);
	const score = factory.EasyScore();
	const prevSystem = appendSystem(score, null);
	appendSystem(score, prevSystem);
	factory.draw();
}
